import {
    Button,
    CompanyAvatar,
    FlexScrollArea,
    FlexScrollAreaContainer,
    Stack,
    Typography,
} from "@biggeo/bg-ui/lab";
import { SwapVertOutline } from "@biggeo/bg-ui/lab/icons";
import { Routes } from "../../navigation/redux/model";

type SwitchToDatalabModalProps = {
    readonly onClose: () => void;
    readonly link?: string;
};

const SwitchToDatalabModal = ({ onClose, link }: SwitchToDatalabModalProps) => {
    const switchToDatalab = () => {
        // Note: Was not able to use Link or useNavigate since the Modal is outside the Router provider
        window.open(link ?? Routes.datalab, "_blank");
        onClose();
    };

    return (
        <FlexScrollAreaContainer height="100%">
            <FlexScrollArea
                sx={{
                    flexDirection: "column",
                    padding: 4,
                    minHeight: (theme) => theme.spacing(26),
                }}
                gap={4}
            >
                <Stack height="100%" width="100%">
                    <CompanyAvatar src="https://sabiggeomedia01.blob.core.windows.net/media/Background.png" />
                    <Typography variant="h6" fontWeight="bold">
                        Datalab Data Management
                    </Typography>
                    <Typography
                        variant="body3"
                        textColor="disabled.onContainer"
                    >
                        Data management is done within your Datalab account.
                        Switch accounts to perform data management actions.
                    </Typography>
                </Stack>
            </FlexScrollArea>
            <Stack
                gap={2}
                sx={{
                    padding: 4,
                }}
            >
                <Button
                    fullWidth
                    endNode={<SwapVertOutline />}
                    onClick={switchToDatalab}
                >
                    Switch To Datalab
                </Button>
                <Button fullWidth variant="outlined" onClick={onClose}>
                    Nevermind
                </Button>
            </Stack>
        </FlexScrollAreaContainer>
    );
};

export default SwitchToDatalabModal;
